import { Button } from '@efexteam/components';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useWhiteLabelService from '@/layout/login/hooks/useWhiteLabel.service';
import LogoController from '@/layout/login/components/LogoController/LogoController';
import { notFound } from '../../assets';

interface IErrorStateProps {
  showBackButton?: boolean;
  close?: () => void;
}

const ErrorState = ({ showBackButton = true, close }: IErrorStateProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { whiteLabelState } = useWhiteLabelService();

  return (
    <Box className="payment max-w-[650px] mx-auto">
      <Box className="flex justify-between items-center mb-4">
        <LogoController
          isWhiteLabel={!!whiteLabelState?.organizationID}
          efexLogoProps={{ className: 'max-w-[150px] ml-4 mt-2' }}
          whiteLabelLogo={whiteLabelState.organizationLogoURL}
        />
        {!showBackButton ? (
          <Button
            appearance="primary"
            variant="text"
            aria-label="Close"
            type="button"
            className="ml-auto block mb-3"
            id="id_download"
            onClick={() => close?.()}
          >
            <CloseIcon />
          </Button>
        ) : (
          <Button
            appearance="primary"
            variant="outlined"
            type="button"
            onClick={() => navigate(-1)}
            className="ml-auto block mb-3"
          >
            <KeyboardBackspaceIcon sx={{ fontSize: 16 }} /> {t('back')}
          </Button>
        )}
      </Box>
      <Box className="max-w-[600px] mx-auto mt-5 text-center">
        <img
          className="max-w-[200px] mb-5 mx-auto"
          src={notFound}
          width="100"
          alt="under_review"
        />
        <Typography variant="h6">{t('invoiceErrorHeader')}</Typography>
        <Typography variant="body1" className="!my-5">
          {t('invoiceErrorBody')}
        </Typography>
      </Box>
    </Box>
  );
};

export default ErrorState;
